import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default class OptGroup extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    label: PropTypes.string.isRequired,
    showGroupLabels: PropTypes.bool,
  };

  static defaultProps = {
    showGroupLabels: true,
  };

  render() {
    return (
      <div className={'OptGroup'}>
        {this.props.showGroupLabels ? (
          <span className={'OptGroup-label'}>{this.props.label}</span>
        ) : (
          <span className={'OptGroup-separator'} />
        )}
        {this.props.children}
      </div>
    );
  }
}
